import React from 'react';
import { Card, Skeleton, SkeletonItem, Divider } from '@fluentui/react-components';
import { useProfileBlockStyles } from './ProfileBlock.styles';

/**
 * Placeholder for Profile Block including the role summary and required skills section
 */
export const ProfileBlockSkeleton = (props: { pageName: string }) => {
  const styles = useProfileBlockStyles();
  /* Widths, in percent, of each of the "skeleton skills" */
  const requiredSkillsSkeletonWidths = [65, 25, 35, 25, 25, 30, 55, 40, 40];
  return (
    <div className={styles.profileContainer}>
      <Card className={styles.profileCard}>
        <Skeleton>
          <div className={styles.skeletonItemContainer}>
            <div className={styles.avatarSkeleton}>
              <SkeletonItem shape="circle" size={48} />
              <div className={styles.avatarSkeletonContainer}>
                {new Array(3).fill(0).map((_, index) => (
                  <SkeletonItem key={index} size={12} style={{ width: index === 2 ? '40%' : '50%' }} />
                ))}
              </div>
            </div>
            <Divider className={styles.divider} />
            {new Array(3).fill(0).map((_, index) => {
              return (
                <React.Fragment key={index}>
                  <SkeletonItem style={{ width: '80%' }} />
                  <SkeletonItem size={12} style={{ width: '40%' }} />
                </React.Fragment>
              );
            })}
          </div>
        </Skeleton>
      </Card>
      {props.pageName == 'RoleLibraryPage' && (
        <Card className={styles.roleContainer}>
          <Card className={styles.innerCards}>
            <Skeleton>
              <div className={styles.skeletonItemContainer}>
                <SkeletonItem size={20} style={{ width: '25%' }} />
                <Divider className={styles.divider} />
                <SkeletonItem style={{ width: '50%' }} />
                <div className={styles.skeletonVerticalAlignment}>
                  <div className={styles.skeletonItemContainer}>
                    {new Array(6).fill(0).map((_data, index) => {
                      return <SkeletonItem key={index} size={8} style={{ width: index == 5 ? '60%' : '90%' }} />;
                    })}
                  </div>
                  <SkeletonItem style={{ width: '20%' }} />
                </div>
              </div>
            </Skeleton>
          </Card>
          <Card className={styles.innerCards}>
            <Skeleton>
              <div className={styles.skeletonItemContainer}>
                <SkeletonItem size={20} style={{ width: '25%' }} />
                <Divider className={styles.divider} />
                <div className={styles.skeletonVerticalAlignment}>
                  <div className={styles.skeletonRowAlignment}>
                    {requiredSkillsSkeletonWidths.map((width, index) => (
                      <SkeletonItem key={index} style={{ width: `${width}%`, borderRadius: '8px' }} />
                    ))}
                  </div>
                  <SkeletonItem style={{ width: '20%' }} />
                </div>
              </div>
            </Skeleton>
          </Card>
        </Card>
      )}
      {props.pageName == 'CareerPlanPage' && (
        <Card className={styles.frameworkStatementContainer}>
          <div className={styles.FrameworkInnerContainer}>
            <SkeletonItem size={20} style={{ width: '55%' }} />
            {new Array(6).fill(0).map((_data, index) => {
              return <SkeletonItem key={index} size={8} style={{ width: index == 5 ? '60%' : '90%' }} />;
            })}
            <div className={styles.skeletonRowAlignment}>
              {new Array(3).fill('30%').map((width, index) => (
                <SkeletonItem key={index} style={{ width: `${width}` }} />
              ))}
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};
